<div class="row">
  <div class="ir-area ir-mask th-mask">
    <form class="ir-modal th-modal" (ngSubmit)="save(editForm.value)" [formGroup]="editForm">
      <div class="ir-modal--title">
        <div class="ir-line--right"></div>
        <div class="ir-line">
          <div class="ir-line-content">
            <span>{{ 'settings.edit-user.edit-password' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
        <div class="ir-content--modal th-content">
          <table class="ir-modal-table">
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'settings.edit-user.current-password' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <validation-message
                    [validationControl]="editForm.controls.currentPassword"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input type="password" name="current" class="ir-form-set" formControlName="currentPassword" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'settings.edit-user.new-password' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <validation-message
                    [validationControl]="editForm.controls.newPassword"
                    [validationName]="'minlength'"
                    [errorMessage]="'common.minlength' | translate: editForm.controls.newPassword.errors?.minlength"
                  ></validation-message>
                  <validation-message
                    [validationControl]="editForm.controls.newPassword"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input type="password" name="new" class="ir-form-set" formControlName="newPassword" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'settings.edit-user.confirmation' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group">
                  <validation-message
                    [validationControl]="editForm.controls.confirmPassword"
                    [validationName]="'minlength'"
                    [errorMessage]="'common.minlength' | translate: editForm.controls.confirmPassword.errors?.minlength"
                  ></validation-message>
                  <p
                    class="ir-required th-required"
                    [class.visible]="
                      editForm.controls.confirmPassword.value &&
                      editForm.controls.newPassword.value &&
                      editForm.controls.newPassword.value !== editForm.controls.confirmPassword.value
                    "
                  >
                    <span>{{ 'common.matchpassword' | translate }}</span>
                  </p>
                  <validation-message
                    [validationControl]="editForm.controls.confirmPassword"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input type="password" name="confirmation" class="ir-form-set" formControlName="confirmPassword" />
                </div>
              </td>
            </tr>
          </table>
          <p *ngIf="isFailed" class="th-txt--error">
            <span style="font-size: 4em; font-weight: 600">{{ 'settings.edit-user.invalid' | translate }}</span>
          </p>
        </div>
      </div>
      <div class="ir-modal--footer ir-position--b th-modal--footer">
        <div class="ir-row">
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
            <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
              <span>{{ 'common.cancel' | translate }}</span>
            </div>
          </div>
          <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
            <button
              class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
              type="submit"
              [disabled]="editForm.invalid"
              *ngIf="!processing"
            >
              <span>{{ 'common.save-changes' | translate }}</span>
            </button>
            <button
              class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
              type="submit"
              *ngIf="processing"
            >
              <span>{{ 'common.processing' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
